// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { type InputHTMLAttributes } from 'react';
import { AppIcon } from '@shared/ui-kit/components/app-icon';

interface SearchBarProps extends InputHTMLAttributes<HTMLInputElement> {
  placeholder?: string;
  leftIcon?: JSX.Element;
  value?: string;
  onChangeValue: (e: React.ChangeEvent<HTMLInputElement>) => void;
  dataTestId?: string;
}

export const SearchBar = ({
  placeholder,
  leftIcon = <AppIcon icon="Search" color="disabled" size="base" />,
  value,
  onChangeValue,
  dataTestId,
  ...props
}: SearchBarProps) => {
  return (
    <div className="relative">
      <input
        className="input-rounded pl-10"
        value={value}
        onChange={e => {
          onChangeValue(e);
        }}
        data-testid={dataTestId}
        placeholder={placeholder}
        type="text"
        autoComplete="off"
        {...props}
      />
      {leftIcon && <div className="absolute left-4 top-3">{leftIcon}</div>}
    </div>
  );
};
